import React, { useState } from "react";
import { Shield, Award, ChevronDown, ChevronUp, ExternalLink } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { RAH_VEER_FLOW_PAUSED } from "../../config/pilot";

const GoodSamaritanGuide = ({ onStartRescue }) => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  const point3Key = RAH_VEER_FLOW_PAUSED ? "public.goodSamaritanPoint3Paused" : "public.goodSamaritanPoint3";

  return (
    <div className="bg-emerald-50 border border-emerald-200 rounded-xl overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-3 px-4 py-3 text-left min-h-14"
      >
        <div className="w-10 h-10 rounded-lg bg-emerald-600 flex items-center justify-center shrink-0">
          <Shield size={20} className="text-white" aria-hidden />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-emerald-900">{t("public.goodSamaritanTitle")}</p>
          {open && (
            <p className="text-xs text-emerald-700 mt-0.5">{t("public.goodSamaritanSubtitle")}</p>
          )}
        </div>
        {open ? (
          <ChevronUp size={20} className="text-emerald-700 shrink-0" />
        ) : (
          <ChevronDown size={20} className="text-emerald-700 shrink-0" />
        )}
      </button>

      {open && (
        <div className="px-4 pb-4 space-y-3 border-t border-emerald-200/80 pt-3 animate-fade-in">
          <ul className="text-sm text-emerald-900 space-y-2 list-disc pl-4">
            <li>{t("public.goodSamaritanPoint1")}</li>
            <li>{t("public.goodSamaritanPoint2")}</li>
            <li>{t(point3Key)}</li>
          </ul>

          <div className="bg-white rounded-lg border border-emerald-200 p-3">
            <div className="flex items-start gap-2">
              <Award size={18} className="text-amber-600 shrink-0 mt-0.5" aria-hidden />
              <div>
                {RAH_VEER_FLOW_PAUSED ? (
                  <>
                    <p className="text-sm font-bold text-slate-900">{t("public.rahVeerInfoTitle")}</p>
                    <p className="text-xs text-slate-600 mt-1 leading-relaxed">{t("public.rahVeerInfoBody")}</p>
                  </>
                ) : (
                  <>
                    <p className="text-sm font-bold text-slate-900">{t("public.rahVeerTitle")}</p>
                    <p className="text-xs text-slate-600 mt-1 leading-relaxed">{t("public.rahVeerHowTo")}</p>
                    <ol className="text-xs text-slate-700 mt-2 space-y-1.5 list-decimal pl-4">
                      <li>{t("public.rahVeerStep1")}</li>
                      <li>{t("public.rahVeerStep2")}</li>
                      <li>{t("public.rahVeerStep3")}</li>
                      <li>{t("public.rahVeerStep4")}</li>
                    </ol>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2">
            {onStartRescue && (
              <button
                type="button"
                onClick={onStartRescue}
                className="flex-1 min-h-11 px-4 rounded-lg bg-emerald-700 text-white text-sm font-bold hover:bg-emerald-800"
              >
                {t("public.startGuidedRescue")}
              </button>
            )}
            <a
              href="https://morth.nic.in/good-samaritan-guidelines"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 min-h-11 px-4 rounded-lg border border-emerald-300 bg-white text-emerald-800 text-sm font-semibold hover:bg-emerald-50 flex items-center justify-center gap-1.5"
            >
              {t("public.goodSamaritanLink")}
              <ExternalLink size={14} aria-hidden />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoodSamaritanGuide;
